import packageJson from '../../package.json';

export const environment = {
  version: packageJson.version,
  production: true,
  isProduction: false,
  isniPath: 'api/isni',
  isrcPath: 'api/isrc',
  stripePath: 'api/stripe',
  emailPath: 'api/email',
  maintenance: {
    enabled: false,
    until: 'September 16th'
  },
  stripe: {
    products : {
      registrationIsni: {
        product_id: "prod_ROH6L92Ry1PAr3",
        price_id: "price_1QVUYADOtH8OnA5kv5VgVxrE",
        price: 1000
      },
      registrationIsrc: {
        product_id: "prod_ROHCToPgquBdnQ",
        price_id: "price_1QVUe6DOtH8OnA5ke3tilHeh",
        price: 0
      },
    }
  }
};
